export const MAX_MEDIA_ITEMS_DESKTOP = 8;
export const MAX_MEDIA_ITEMS_MOBILE = 8;
export const MEDIA_COLUMN_DESKTOP = 4;
export const MEDIA_COLUMN_MOBILE = 2;
